import React from 'react';
import RedeemCard from "../features/redeemCard/components/RedeemCard";

const RedeemCardPage = () => {
    return <RedeemCard />;
};

export default RedeemCardPage;
